import gql from 'graphql-tag';

export default gql`
  mutation processXpayResponse($query_string: String!) {
    processXpayResponse(query_string: $query_string) {
      id
      total
      currency {
        code
      }
      info {
        total_usd
        report_to_analytics
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./app/containers/Checkout/graphql/xpayMutation.gql.js